import { render } from "./ImageModal.vue?vue&type=template&id=363e6668"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__